// import { param } from "jquery";

// import echarts from "echarts/types/dist/echarts";

export class ChartOption {
    LineChartOption() {
        return {
            textStyle: {
                fontFamily: 'Figtree,Anuphan'
            },
            grid: {
                width: '88%',
                height: '65%',
                top: "18%",
                left: "5%",
                right: "0%",
                bottom: "0%",
            },
            legend: {
                width: "100%",
                show: true,
                data: [],
                left: 'center',
                textStyle: {
                    color: '#333',
                    fontSize: 10
                },
                itemWidth: 10,
                itemHeight: 10,
            },
            dataZoom: [
                {
                    type: "inside",
                },
            ],
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "axis",
                textStyle: {
                    fontWeight: '400',
                    fontSize: 11
                }
            },
            xAxis: {
                type: "category",
                boundaryGap: false,
                data: [],
                axisLine: {},
                splitLine: {},
                axisLabel: {
                    fontSize: 10,
                    color: '#AAAAAA'
                }
            },
            yAxis: {
                type: "value",
                axisLine: {
                    lineStyle: {},
                },
                splitLine: {},

            },
            series: [],
        };
    }

    SumMeterChartOption() {
        return {
            color: ["#ffb800", "#5fb545"],
            tooltip: {
                formatter: '{b}:00 <br/><i class="fas fa-circle" style="color: #ffb800"></i> Energy Yield : <b>{c0}</b> kWh<br/><i class="fas fa-circle" style="color: #5fb545"></i> Revenes : <b>{c1}</b> THB',
                trigger: "axis",
                axisPointer: {
                    type: "cross",
                },
            },
            toolbox: {
                feature: {
                    dataView: { show: true, readOnly: false },
                    restore: { show: true },
                    saveAsImage: { show: true },
                },
            },
            legend: {
                data: ["Energy Yield (kWh)", "Revenes (THB)"],
            },
            xAxis: [
                {
                    type: "category",
                    axisTick: {
                        alignWithLabel: true,
                    },
                    data: [],
                },
            ],
            yAxis: [
                {
                    type: "value",
                    name: "Energy Yield (kWh)",
                    position: "left",
                    alignTicks: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#ffb800",
                        },
                    },
                    axisLabel: {
                        formatter: "{value} kWh",
                    },
                },
                {
                    type: "value",
                    name: "Revenes (THB)",
                    position: "right",
                    alignTicks: true,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#5fb545",
                        },
                    },
                    axisLabel: {
                        formatter: "{value} THB",
                    },
                },
            ],
            series: [],
        };
    }

    PieChartOption() {
        return {
            grid: {
                left: "0%",
                top: "0%",
                right: "0%",
                bottom: "0%",
            },
            tooltip: {
                trigger: "item",
            },
            series: [
                {
                    name: "",
                    type: "pie",
                    radius: ["40%", "70%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: "#fff",
                        borderWidth: 2,
                    },
                    label: {
                        show: false,
                        position: "center",
                    },
                    color: ["#adff2f", "#ffa500", "#ff0000"],
                    emphasis: {
                        label: {
                            show: true,
                            fontWeight: "bold",
                        },
                    },
                    labelLine: {
                        show: false,
                    },
                    data: [
                        { value: 1048, name: "Search Engine" },
                        { value: 735, name: "Direct" },
                        { value: 580, name: "Email" },
                    ],
                },
            ],
        };
    }

    analyticsChart() {
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                type: 'category',
                data: ['Management',]
            },
            grid: {
                left: "30%",
                top: "5%",
                right: "0%",
                bottom: "5%",
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: 'O&M',
                    data: [1000000],
                    type: 'bar'
                }, {
                    name: 'Target O&M',
                    data: [10000000],
                    type: 'bar'
                }
            ]
        };
    }

    analyticsChart1() {
        return {
            tooltip: {
                trigger: "item",
            },
            legend: {
                bottom: 0,
                left: "center",
            },
            series: [
                {
                    name: "",
                    type: "pie",
                    radius: ["40%", "70%"],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: "center",
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: 20,
                            fontWeight: "bold",
                        },
                    },
                    labelLine: {
                        show: false,
                    },
                    data: [
                        { value: 1048, name: "Search Engine" },
                        { value: 735, name: "Direct" },
                        { value: 580, name: "Email" },
                        { value: 484, name: "Union Ads" },
                        { value: 300, name: "Video Ads" },
                    ],
                },
            ],
        };
    }

    TotalChart() {
        return {
            tooltip: {
                trigger: "item",
            },
            legend: {
                bottom: -10,
                left: "center",
            },
            color: ["#adff2f", "#ffa500", "#ff0000"],
            series: [
                {
                    name: "",
                    type: "pie",
                    radius: ["40%", "62%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: "#fff",
                        borderWidth: 2,
                    },
                    label: {
                        show: false,
                        position: "center",
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: 20,
                            fontWeight: "bold",
                        },
                    },
                    labelLine: {
                        show: false,
                    },
                    data: [],
                },
            ],
        };
    }

    OrdersChart() {
        return {
            tooltip: {
                trigger: "item",
            },
            legend: {
                bottom: -10,
                left: "center",
            },
            color: ["#ff0000", "#ffa500", "#adff2f", '#008ffb'],
            series: [
                {
                    name: "",
                    type: "pie",
                    radius: ["40%", "62%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: "#fff",
                        borderWidth: 2,
                    },
                    label: {
                        show: false,
                        position: "center",
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: 20,
                            fontWeight: "bold",
                        },
                    },
                    labelLine: {
                        show: false,
                    },
                    data: [],
                },
            ],
        };
    }


    // MapChartOption() {
    //     return {
    //         tooltip: {
    //             renderMode: 'html',
    //             shadowColor: '#D0E3FE',
    //             shadowBlur: 20,
    //             padding: 0,
    //             textStyle: {
    //                 fontSize: 16,
    //             },
    //             trigger: 'item',
    //             triggerOn: 'click',
    //             enterable: true,
    //             borderWidth: 0,
    //         },
    //         geo: {
    //             map: 'Thailand',
    //             aspectScale: 1,
    //             roam: true,
    //             zoom: 1,
    //             layoutCenter: ['50%', '50%'],
    //             layoutSize: '100%',
    //             scaleLimit: {
    //                 min: 1,
    //                 max: 40
    //             },
    //             label: {
    //                 color: '#FDFEFE',
    //             },
    //             itemStyle: {
    //                 label: {

    //                 },
    //                 emphasis: {
    //                     label: {
    //                         show: true,
    //                         color: '#FDFEFE',
    //                     }
    //                 }
    //             },
    //             regions: [],
    //             tooltip: {
    //                 formatter: function (params) {
    //                     if (params.seriesType === 'scatter' && params.componentIndex === 1) {
    //                         let text = ''
    //                         let link = '';

    //                         for (let i = 0; i < params.data.value.length; i++) {
    //                             // console.log( params.data.value[i])
    //                             if (i > 2) {
    //                                 const inputString = params.data.value[i].table;
    //                                 const result = inputString.match(/\d+/)[0];
    //                                 link += `<b style="color:${params.data.itemStyle.color};margin-bottom:2%;font-size:1.2vh">&#9679; &nbsp<a href="/solar/${result}/${inputString}/${params.data.value[i].id}">${params.data.value[i].name}</a></b>`
    //                             }
    //                         }
    //                         text = `
    //                         <div style="min-width: 16vw;max-height:22vh;overflow:auto;">
    //                             <div style="background: linear-gradient(0deg, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 0%,${params.data.itemStyle.color} 28%,${params.data.itemStyle.color} 90%);display:flex;justify-content:center;align-items:center;padding:5%;border-top-left-radius:3px;border-top-right-radius:3px">
    //                                 <h4 style="margin-bottom: 5%;color:#FDFEFE;font-size:1.7vh">${params.name}</h4>
    //                             </div>
    //                             <div style="white-space: normal;padding:5%;display:flex;flex-direction:column;justify-content:evenly;font-size:1.3vh"> 
    //                                 ${link}
    //                             </div>
    //                     </div>`;

    //                         return text;
    //                     } else {
    //                         return '';
    //                     }
    //                 },
    //             }
    //         },
    //         series: [
    //             {
    //                 //markpoint
    //                 type: 'scatter',
    //                 coordinateSystem: 'geo',
    //                 data: [],
    //                 symbol: 'pin',
    //                 symbolSize: 25,
    //                 label: {
    //                     show: false,
    //                     formatter: '{b}',
    //                     fontSize: 15,
    //                     position: 'inside',
    //                     fontWeight: 'bold',
    //                 },
    //                 itemStyle: {
    //                     color: '#22A699',
    //                     shadowColor: '#22A699',
    //                     shadowBlur: 5,
    //                     emphasis: {
    //                         label: {
    //                             show: true,
    //                             position: 'top',
    //                         }
    //                     }

    //                 },

    //             },
    //             {
    //                 type: 'scatter',
    //                 coordinateSystem: 'geo',
    //                 data: [],
    //                 symbol: 'rect',
    //                 symbolSize: [160, 50],
    //                 label: {
    //                     color: '#FFFFFF',
    //                     show: true,
    //                     formatter: '{b} POWER (kW) \n {@[2]}',
    //                     fontSize: 11,
    //                     position: 'inside',
    //                     fontWeight: 'bold',
    //                 },
    //                 itemStyle: {
    //                     shadowColor: '#D0E3FE',
    //                     shadowBlur: 15,
    //                     emphasis: {
    //                         label: {
    //                             fontSize: 12,
    //                         }
    //                     }

    //                 },
    //             },
    //         ],
    //     };
    // }



    gauge() {
        return {
            series: [
                {
                    type: 'gauge',
                    center: ['50%', '80%'],
                    radius: '150%',
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: 100,
                    splitNumber: 12,
                    itemStyle: {
                        color: '#2D9056'
                    },
                    progress: {
                        show: true,
                        width: 7,
                        roundCap: true,
                    },
                    pointer: {
                        show: false
                    },
                    axisLine: {
                        roundCap: true,
                        lineStyle: {
                            width: 7,
                            roundCap: true,
                            color: [
                                [0.5, '#98C721'],
                                [1, '#F69433']
                            ]
                        }
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false // ซ่อนเส้นขีดเล็กบนเส้นวงกลม
                    },
                    splitLine: {
                        show: false
                    },
                    detail: {
                        valueAnimation: true,
                        width: '50%',
                        borderRadius: 8,
                        offsetCenter: [0, '-15%'],
                        fontSize: 13,
                        formatter: '{value} °C',
                        color: 'inherit'
                    },
                    data: [
                        {
                            value: 0
                        }
                    ]
                },
            ],
        }
    }




    PieChartOption2() {
        return {
            tooltip: {
                trigger: 'item'
            },
            series: [
                {
                    name: 'Today',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        formatter: '{a}',
                        fontSize: 13
                    },
                    itemStyle: {
                        borderRadius: 5,
                        borderColor: "#ffffff",
                        borderWidth: 2,
                    },
                    // emphasis: {
                    // },
                    data: []
                }
            ]
        }
    }


    StackedBar() {
        return {
            textStyle: {
                fontFamily: 'Figtree,Anuphan'
            },
            grid: {
                width: '85%',
                height: '70%',
                left: "7%",
                top: "10%",
                right: "0%",
                bottom: "0%",
            },
            dataZoom: [
                {
                    type: 'inside'
                }
            ],
            tooltip: {
                formatter: ()=>{},
                trigger: "axis",
                axisPointer: {
                    type: "cross",
                },
                textStyle: {
                    fontWeight: '400',
                    fontSize: 11
                },

            },
            xAxis: {
                data: [],
                axisLabel: {
                    fontSize: 10,
                    color: '#AAAAAA'
                }
            },
            yAxis: {
                type: "value",
                axisLine: {
                    lineStyle: {},
                },
                splitLine: {},
            },
            series: [],
        };
    }
    docChart() {
        return {
            title: {
                text: ''
            },
            legend: {},
            tooltip: {
                trigger: 'axis',
            },
            xAxis: {
                type: 'category',
                data: []
            },
            yAxis: {
                type: 'value',
                boundaryGap: [0, '100%'],
                min: 0
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 500
                },
                {
                    start: 0,
                    end: 500
                }
            ],
            series: []
        }
    }

    gauge2() {
        return {
            series: [
                {
                    type: 'gauge',
                    center: ['50%', '60%'],
                    startAngle: 210,
                    endAngle: '-30',
                    min: 0,
                    max: 100,
                    radius: '100%',
                    axisLine: {
                        lineStyle: {
                            width: 15,
                            color: [
                                [0.0, '#b2f5ff'],
                                [0.04, '#b2f1ff'],
                                [0.08, '#b2f9ff'],
                                [0.10, '#b2feff'],
                                [0.14, '#b2ffd4'],
                                [0.18, '#b2ffca'],
                                [0.22, '#b2ffbe'],
                                [0.26, '#b2ffb5'],
                                [0.30, '#b8ffb2'],
                                [0.34, '#c1ffb2'],
                                [0.38, '#b9ffb2'],
                                [0.42, '#c4ffb2'],
                                [0.46, '#d7ffb2'],
                                [0.50, '#eaffb2'],
                                [0.54, '#f7ffb2'],
                                [0.58, '#fffab2'],
                                [0.62, '#ffe57f'],
                                [0.66, '#ffe37f'],
                                [0.70, '#ffd47f'],
                                [0.74, '#ffc27f'],
                                [0.78, '#ffb67f'],
                                [0.82, '#ffa97f'],
                                [0.86, '#ffa07f'],
                                [0.92, '#ff937f'],
                                [0.96, '#ff776f'],
                                [1, '#ff6969']
                            ]
                        }
                    },
                    pointer: {
                        icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                        length: '15%',
                        width: 10,
                        offsetCenter: [0, '-62%'],
                        itemStyle: {
                            color: 'auto'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    title: {
                        offsetCenter: [0, '35%'],
                        fontSize: 14,
                        color: '#c9c9c9',
                        fontFamily: 'Figtree'
                    },
                    detail: {
                        offsetCenter: [0, '-5%'],
                        valueAnimation: true,
                        color: 'inherit',
                        formatter: (value: any) => { },
                        rich: {
                            valueStyle: {
                                fontSize: 40,
                                color: '#333',
                                fontFamily: 'Figtree'
                            },
                            unitStyle: {
                                fontSize: 17,
                                fontWeight: 'normal',
                                color: '#c9c9c9',
                                fontFamily: 'Figtree',
                            }
                        },
                    },

                    data: []

                }
            ]
        };
    }
}